import { render, staticRenderFns } from "./History.vue?vue&type=template&id=4273f7fe&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4273f7fe')) {
      api.createRecord('4273f7fe', component.options)
    } else {
      api.reload('4273f7fe', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=4273f7fe&", function () {
      api.rerender('4273f7fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PushMessage/History.vue"
export default component.exports